import { DocumentConstants } from "../types/DocumentConstants";

export const DocumentActions = {
  assignDocToPatient,
  assignDocToPatientSuccess,
  assignDocToPatientError,
  getALLDocRequest,
  getALLDocSuccess,
  getALLDocError,
  getActiveDocRequest,
  getActiveDocSuccess,
  getActiveDocError,
  getPendingDocRequest,
  getPendingDocSuccess,
  getPendingDocError,
  submitDocRequest,
  submitDocSuccess,
  submitDocError,
  cancelRequest,
  cancelSuccess,
  cancelError,
  getDocByIdRequest,
  getDocByIdSuccess,
  getDocByIdError,
  clearAll,
};

function assignDocToPatient(data) {
  return { type: DocumentConstants.ASSIGN_DOC_PATIENT_REQUEST, data };
}
function assignDocToPatientSuccess() {
  return { type: DocumentConstants.ASSIGN_DOC_PATIENT_SUCCESS };
}
function assignDocToPatientError() {
  return { type: DocumentConstants.ASSIGN_DOC_PATIENT_FAILIURE };
}
function getALLDocRequest(id) {
  return { type: DocumentConstants.GET_ALL_DOC_REQUEST, id };
}
function getALLDocSuccess(data) {
  return { type: DocumentConstants.GET_ALL_DOC_SUCCESS, data };
}
function getALLDocError() {
  return { type: DocumentConstants.GET_ALL_DOC_FAILIURE };
}

function getActiveDocRequest(id) {
  return { type: DocumentConstants.GET_ACTIVE_DOC_REQUEST, id };
}
function getActiveDocSuccess(data) {
  return { type: DocumentConstants.GET_ACTIVE_DOC_SUCCESS, data };
}
function getActiveDocError() {
  return { type: DocumentConstants.GET_ACTIVE_DOC_FAILIURE };
}

function getPendingDocRequest(id) {
  return { type: DocumentConstants.GET_PENDING_DOC_REQUEST, id };
}
function getPendingDocSuccess(data) {
  return { type: DocumentConstants.GET_PENDING_DOC_SUCCESS, data };
}
function getPendingDocError() {
  return { type: DocumentConstants.GET_PENDING_DOC_FAILIURE };
}

function submitDocRequest(data) {
  return { type: DocumentConstants.SUBMIT_DOC_REQUEST, data };
}
function submitDocSuccess() {
  return { type: DocumentConstants.SUBMIT_DOC_SUCCESS };
}
function submitDocError() {
  return { type: DocumentConstants.SUBMIT_DOC_FAILIURE };
}

function cancelRequest(id) {
  return { type: DocumentConstants.CANCEL_DOC_REQUEST, id };
}
function cancelSuccess() {
  return { type: DocumentConstants.CANCEL_DOC_SUCCESS };
}
function cancelError() {
  return { type: DocumentConstants.CANCEL_DOC_FAILIURE };
}

function getDocByIdRequest(id) {
  return { type: DocumentConstants.GET_DOC_BY_ID_REQUEST, id };
}
function getDocByIdSuccess(data) {
  return { type: DocumentConstants.GET_DOC_BY_ID_SUCCESS, data };
}
function getDocByIdError() {
  return { type: DocumentConstants.GET_DOC_BY_ID_FAILIURE };
}
function clearAll() {
  return { type: DocumentConstants.CLEAR_ALL_DOCUMENT_DETAILS };
}

